import { z } from "zod";

/** Inpatient Phase 7 — billing: itemised admission charges + bill summary. */

export const chargeTypeSchema = z.enum([
	"bed",
	"service",
	"procedure",
	"medication",
	"consumable",
	"other",
]);
export type ChargeType = z.infer<typeof chargeTypeSchema>;

const moneyString = z
	.string()
	.regex(/^\d{1,13}(\.\d{1,2})?$/u, "Invalid amount");

export const admissionChargeApiSchema = z.object({
	id: z.string().uuid(),
	admission_id: z.string().uuid(),
	charge_type: z.string(),
	description: z.string(),
	quantity: z.string(),
	unit_price: z.string(),
	amount: z.string(),
	charged_at: z.string().datetime(),
	recorded_by_member_id: z.string().uuid().nullable(),
});
export type AdmissionChargeApi = z.infer<typeof admissionChargeApiSchema>;

export const addAdmissionChargeInputSchema = z.object({
	admission_id: z.string().uuid(),
	charge_type: chargeTypeSchema,
	description: z.string().min(1).max(300),
	quantity: z.coerce.number().min(0.01).max(100000).optional(),
	unit_price: moneyString,
});
export type AddAdmissionChargeInput = z.infer<
	typeof addAdmissionChargeInputSchema
>;

/** Bill summary for an admission (deterministic). */
export const admissionBillSchema = z.object({
	items: z.array(admissionChargeApiSchema),
	total: z.string(),
	/** Length of stay in days (admit → discharge or now), at least 1. */
	los_days: z.number().int(),
});
export type AdmissionBill = z.infer<typeof admissionBillSchema>;
